// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== 1. Sección Superior "Hablemos" ===== */
.Contacto_heroSection__uf4fQ {
  padding: 80px 5%;
  background-color: #000000; 
}

.Contacto_heroContainer__dSTBK {
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 60px;
}

.Contacto_heroContent__Wkdwb {
  width: 600px; 
  height: auto; 
  background-color: rgb(255, 255, 255);
  padding: 40px;
  border-radius: 8px;
  text-align: left; 
}

.Contacto_heroContent__Wkdwb h2 {
  font-size: 42px;
  font-weight: 800;
  color: var(--textoNegro);
  margin-bottom: 20px;
  line-height: 1.2;
}

.Contacto_heroContent__Wkdwb p {
  font-size: 17px;
  color: #555;
  line-height: 1.8;
  max-width: 500px; 
}

.Contacto_heroImageWrapper__8zFAP {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
}

.Contacto_heroImage__Hh7Jr {
  width: 100%;
  display: block;
  padding: 0; 
  aspect-ratio: 0 / 1; 
  object-fit: cover;
}

@media (max-width: 1024px) { 
  .Contacto_heroSection__uf4fQ { padding: 60px 5%; }
  
  .Contacto_heroContainer__dSTBK {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center; 
  }

  .Contacto_heroContent__Wkdwb {
    width: 100%;
    height: auto;
    padding: 30px; 
    order: 2;
    margin: 0 auto; 
  }

  .Contacto_heroContent__Wkdwb p { 
      margin: 0 auto 0 auto;
      max-width: 100%; 
  }
   
  .Contacto_heroImageWrapper__8zFAP { 
      order: 1; 
      max-width: 100%; 
      margin: 0 auto;
  } 
  
  .Contacto_heroContent__Wkdwb h2 { 
      font-size: 34px; 
  }

}

`, "",{"version":3,"sources":["webpack://./src/components/Contacto.module.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,+BAAe,gBAAgB,EAAE;;EAEjC;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,cAAc;EAChB;;EAEA;MACI,qBAAqB;MACrB,eAAe;EACnB;;EAEA;MACI,QAAQ;MACR,eAAe;MACf,cAAc;EAClB;;EAEA;MACI,eAAe;EACnB;;AAEF","sourcesContent":["/* ===== 1. Sección Superior \"Hablemos\" ===== */\n.heroSection {\n  padding: 80px 5%;\n  background-color: #000000; \n}\n\n.heroContainer {\n  max-width: 1100px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  align-items: center;\n  gap: 60px;\n}\n\n.heroContent {\n  width: 600px; \n  height: auto; \n  background-color: rgb(255, 255, 255);\n  padding: 40px;\n  border-radius: 8px;\n  text-align: left; \n}\n\n.heroContent h2 {\n  font-size: 42px;\n  font-weight: 800;\n  color: var(--textoNegro);\n  margin-bottom: 20px;\n  line-height: 1.2;\n}\n\n.heroContent p {\n  font-size: 17px;\n  color: #555;\n  line-height: 1.8;\n  max-width: 500px; \n}\n\n.heroImageWrapper {\n  width: 100%;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 10px 25px rgba(0,0,0,0.1);\n}\n\n.heroImage {\n  width: 100%;\n  display: block;\n  padding: 0; \n  aspect-ratio: 0 / 1; \n  object-fit: cover;\n}\n\n@media (max-width: 1024px) { \n  .heroSection { padding: 60px 5%; }\n  \n  .heroContainer {\n    grid-template-columns: 1fr;\n    gap: 40px;\n    text-align: center; \n  }\n\n  .heroContent {\n    width: 100%;\n    height: auto;\n    padding: 30px; \n    order: 2;\n    margin: 0 auto; \n  }\n\n  .heroContent p { \n      margin: 0 auto 0 auto;\n      max-width: 100%; \n  }\n   \n  .heroImageWrapper { \n      order: 1; \n      max-width: 100%; \n      margin: 0 auto;\n  } \n  \n  .heroContent h2 { \n      font-size: 34px; \n  }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroSection": `Contacto_heroSection__uf4fQ`,
	"heroContainer": `Contacto_heroContainer__dSTBK`,
	"heroContent": `Contacto_heroContent__Wkdwb`,
	"heroImageWrapper": `Contacto_heroImageWrapper__8zFAP`,
	"heroImage": `Contacto_heroImage__Hh7Jr`
};
export default ___CSS_LOADER_EXPORT___;
